{
  "route": "stars",
  "railEntries": [
    {
      "label": "Orientation",
      "anchor": "stars-section-1"
    },
    {
      "label": "Contrast",
      "anchor": "stars-section-2"
    },
    {
      "label": "Shared ground",
      "anchor": "stars-section-3"
    },
    {
      "label": "Correction",
      "anchor": "stars-section-4"
    },
    {
      "label": "Reality check",
      "anchor": "stars-section-5"
    }
  ],
  "anchors": [
    "stars-section-1",
    "stars-section-2",
    "stars-section-3",
    "stars-section-4",
    "stars-section-5"
  ],
  "nodes": [
    {
      "tag": "section",
      "attrs": {
        "class": "route chapter stars-chapter",
        "id": "route-stars",
        "aria-labelledby": "stars-title"
      },
      "children": [
        {
          "tag": "div",
          "attrs": {
            "class": "wrap"
          },
          "children": [
            {
              "tag": "header",
              "attrs": {
                "class": "chapter-hero"
              },
              "children": [
                {
                  "tag": "div",
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "chapter-index"
                      },
                      "children": [
                        "03 · The Ground"
                      ]
                    },
                    " ",
                    {
                      "tag": "h1",
                      "attrs": {
                        "id": "stars-title"
                      },
                      "children": [
                        "I Eat the Stars & ",
                        {
                          "tag": "em",
                          "children": [
                            "the long now."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "chapter-deck"
                      },
                      "children": [
                        "Sarah Wilson begins from a harsher temporal claim: systemic decline is not a future threshold waiting to be crossed. It is uneven, interconnected and already shaping the conditions of life."
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "aside",
                  "attrs": {
                    "class": "chapter-aside"
                  },
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Research note"
                      ]
                    },
                    "This is a source-led orientation, not a page-by-page review. It is built from Penguin’s synopsis, Wilson’s publication notes and substantive 2026 interviews. ",
                    {
                      "tag": "a",
                      "attrs": {
                        "class": "source-link",
                        "href": "https://www.penguin.com.au/books/i-eat-the-stars-9781761620775",
                        "target": "_blank",
                        "rel": "noreferrer"
                      },
                      "children": [
                        "[S03]"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "chapter-body"
              },
              "children": [
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stars-section-1"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "What the book is doing"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "It is less a collapse forecast than a practice for ",
                            {
                              "tag": "em",
                              "children": [
                                "remaining fully alive."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "lead"
                      },
                      "children": [
                        "The book treats collapse as the unravelling of interconnected complex systems (ecological, economic, political and social) at different speeds in different places. Its central question is not how to restore the old normal, but how to act with truth, justice, beauty and community inside uncertainty. ",
                        {
                          "tag": "a",
                          "attrs": {
                            "class": "source-link",
                            "href": "https://www.theguardian.com/wellness/2026/jul/29/sarah-wilson-book-interview",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "[S04]"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel accent"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "evidence-label synthesis"
                          },
                          "children": [
                            "The first-hour effect"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "You heard the book’s deliberately darkest movement first."
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "One hour is only about a tenth of the 9h28 audiobook and sits largely inside its opening arc of hope, relief, truth and collapse, before the later turn toward post-blame, duty, community, art and homecoming. The opposite energy is real; it is not yet the book’s whole movement. ",
                            {
                              "tag": "a",
                              "attrs": {
                                "class": "source-link",
                                "href": "https://sarahwilson.substack.com/p/table-of-contents",
                                "target": "_blank",
                                "rel": "noreferrer"
                              },
                              "children": [
                                "[S05A]"
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid four"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Book thesis"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Tell the truth"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Simple, linear problem–solution stories cannot hold a polycrisis of interacting systems."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Book thesis"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Stay human"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "A sturdy nervous system, grief and joy are civic capacities, not indulgences."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Book thesis"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Go local"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Community, mutual reliance and “islands of sanity” become practical infrastructure."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Book thesis"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Keep acting"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Uncertainty does not cancel democracy, protest, justice or responsibility."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stars-section-2"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Why it felt opposite"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "One looks toward ignition. The other looks ",
                            {
                              "tag": "em",
                              "children": [
                                "under our feet."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "table",
                      "attrs": {
                        "class": "comparison"
                      },
                      "children": [
                        {
                          "tag": "thead",
                          "children": [
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "th",
                                  "children": [
                                    "Question"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "Stellar"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "I Eat the Stars"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "Third-way reading"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "tbody",
                          "children": [
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Primary future"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Rapid phase change into technological abundance."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Uneven decline across interconnected systems."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Breakthrough and breakdown can arrive together."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Change vehicle"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Disruptive technology plus a new organising system."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Truth, local relationship, democratic action and inner capacity."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Technology expands options; governance determines distribution."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Time stance"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Prepare the sunrise before it ignites."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Learn to live and act inside an already unstable present."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Build before, operate through, adapt beyond shocks."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Core danger"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "The Chimera: abundance captured by extraction."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Denial, brittle hope and fantasies of returning to normal."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Design against both capture and collapse fatalism."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Human task"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Grow nurseries for the next system."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Become sturdy, connected and capable of moral action."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Pair institution-building with relational capacity."
                                  ]
                                }
                              ]
                            },
                            " "
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stars-section-3"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The hidden agreement"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Opposite forecasts. A surprisingly ",
                            {
                              "tag": "em",
                              "children": [
                                "shared diagnosis."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "axiom-list"
                      },
                      "children": [
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "01"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "The old system cannot simply be repaired back to normal."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "02"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Extraction and concentration sit beneath multiple crises."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "03"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Transition is liminal, non-linear and psychologically demanding."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "04"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "New human and community capacity must be built now."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stars-section-4"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The correction"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "This book does not negate your mission. It makes it ",
                            {
                              "tag": "em",
                              "children": [
                                "shock-capable."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "quote-panel"
                      },
                      "children": [
                        {
                          "tag": "blockquote",
                          "children": [
                            "Earth 2.0 asked how to move ",
                            {
                              "tag": "em",
                              "children": [
                                "before the crash."
                              ]
                            },
                            " The new question is how the same architecture holds when the crash is partial, local, repeated, or already here."
                          ]
                        },
                        {
                          "tag": "cite",
                          "children": [
                            "Earth 3.0 synthesis"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Its gift to the model"
                              ]
                            },
                            {
                              "tag": "h2",
                              "children": [
                                "Ground truth"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "It adds emotional realism, local resilience, democratic defence and the possibility that no clean transition window will arrive."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Its limit as a model"
                              ]
                            },
                            {
                              "tag": "h2",
                              "children": [
                                "No complete operating architecture"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "It can orient a life and culture, but it does not by itself specify authority, funding, representation, delivery or how institutions coordinate a just transition."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stars-section-5"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Reality check"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "The wider evidence supports urgency, ",
                            {
                              "tag": "em",
                              "children": [
                                "not certainty about one trajectory."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid three"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label"
                              },
                              "children": [
                                "Verified source"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Planetary boundaries"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The 2025 update reports seven of nine boundaries breached, reinforcing the depth of ecological risk. ",
                                {
                                  "tag": "a",
                                  "attrs": {
                                    "class": "source-link",
                                    "href": "https://www.stockholmresilience.org/research/planetary-boundaries.html",
                                    "target": "_blank",
                                    "rel": "noreferrer"
                                  },
                                  "children": [
                                    "[S06]"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label"
                              },
                              "children": [
                                "Verified source"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Narrowing window"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The IPCC’s synthesis shows rapidly narrowing feasible pathways as warming increases. ",
                                {
                                  "tag": "a",
                                  "attrs": {
                                    "class": "source-link",
                                    "href": "https://www.ipcc.ch/report/ar6/syr/figures/summary-for-policymakers/figure-spm-6/",
                                    "target": "_blank",
                                    "rel": "noreferrer"
                                  },
                                  "children": [
                                    "[S07]"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label"
                              },
                              "children": [
                                "Counterpoint"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Risk is conditional"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Historical research finds that shocks do not automatically produce collapse; interacting inequality, elite conflict and state capacity shape outcomes. ",
                                {
                                  "tag": "a",
                                  "attrs": {
                                    "class": "source-link",
                                    "href": "https://royalsocietypublishing.org/rstb/article/378/1889/20220402/109358/Navigating-polycrisis-long-run-socio-cultural",
                                    "target": "_blank",
                                    "rel": "noreferrer"
                                  },
                                  "children": [
                                    "[S08]"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "button",
                  "attrs": {
                    "class": "route-next",
                    "type": "button",
                    "data-go": "earth3"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Next field"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Earth 3.0 · The Third Way →"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "footer",
                  "attrs": {
                    "class": "tiny-footer"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "03 · I Eat the Stars"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Collapse awareness without surrender"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " "
      ]
    },
    " "
  ]
}
